import React from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import {FiArrowRight} from "react-icons/fi";
import ScrollAnimation from "react-animate-on-scroll";

const TabOne = () => {
    return (
        <div>
            <div className="row">
                <div className="col-lg-12">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        animateOut="fadeInOut"
                        animateOnce={true}>
                        <Tabs>
                            <div className="row row--30 align-items-center">
                                <div className="col-lg-12 mt_md--40 mt_sm--40">
                                    <div className="rn-default-tab">
                                        <div className="tab-button-panel">
                                            <TabList className="tab-button">
                                                <Tab>
                                                    <div className="rn-tab-button">
                                                        <button>MPESA</button>
                                                    </div>
                                                </Tab>
                                                <Tab>
                                                    <div className="rn-tab-button">
                                                        <button>PayPal</button>
                                                    </div>
                                                </Tab>
                                                <Tab>
                                                    <div className="rn-tab-button">
                                                        <button>USSD</button>
                                                    </div>
                                                </Tab>
                                                <Tab>
                                                    <div className="rn-tab-button">
                                                        <button>SMS</button>
                                                    </div>
                                                </Tab>
                                            </TabList>
                                        </div>

                                        <div className="tab-content-panel">
                                            <TabPanel>
                                                <div className="rn-tab-content">
                                                    <div className="inner">
                                                        <p>
                                                            We create a checkout page on your website or online shopping
                                                            application where the customer clicks "Complete Payment" or
                                                            any
                                                            other informative button of your choice using the Mpesa
                                                            integration through the Daraja API. This operation notifies
                                                            the
                                                            MPESA system of the amount that the customer must pay for a
                                                            good
                                                            or service, their phone number, and your pay bill or till
                                                            number.
                                                        </p>
                                                        <p>
                                                            Once the request has been processed, a push message with
                                                            a prompt to enter the MPESA PIN only is delivered to the
                                                            client's phone number. The customer will be redirected to
                                                            the
                                                            following page, which shows the order details and payment
                                                            data,
                                                            after completing the payment via the phone number, according
                                                            to
                                                            your website.
                                                        </p>
                                                        <div className="button-group">
                                                            <a className="btn-default btn-small"
                                                               href="tel:0713958492"> Read
                                                                More <i
                                                                    className="icon"><FiArrowRight/></i></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                            <TabPanel>
                                                <div className="rn-tab-content">
                                                    <div className="inner">
                                                        <p>
                                                            PayPal will make your payments secure and simple to complete
                                                            whether you're utilizing a website to offer goods or
                                                            services.
                                                            We integrate PayPal on your website, which directs visitors
                                                            to
                                                            go to PayPal to register or log in in order to make a
                                                            transaction, assisting you in promoting financial
                                                            transactions.
                                                            We make sure a callback to your website is delivered after
                                                            the
                                                            PayPal transaction is complete so that the consumer can
                                                            receive
                                                            a payment notification, enabling you to swiftly provide
                                                            digital
                                                            products to your customers.
                                                        </p>
                                                        <div className="button-group">
                                                            <a className="btn-default btn-small"
                                                               href="tel:0713958492"> Read
                                                                More <i
                                                                    className="icon"><FiArrowRight/></i></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPanel>

                                            <TabPanel>
                                                <div className="rn-tab-content">
                                                    <div className="inner">
                                                        <p>
                                                            In addition to hosting the application, writing the logic,
                                                            designing the database structure, or just integrating to an
                                                            existing system or application, we assist businesses in
                                                            developing USSD apps.
                                                        </p>
                                                        <p>
                                                            Mixon can also assist you in the registration of your
                                                            shortcode.
                                                            There are two types of shortcodes<br/>
                                                            <ul>
                                                                <li>
                                                                    <b>Dedicated Shortcode:</b> A three-digit code, like
                                                                    *483#, that is
                                                                    only used by one person to promote their product or
                                                                    service.
                                                                </li>
                                                                <li>
                                                                    <b>Shared Shortcode:</b> A shared shortcode is one
                                                                    that
                                                                    is utilized by
                                                                    numerous businesses or services. On our specialized
                                                                    codes, such
                                                                    as *483*15#, each organization is given a specific
                                                                    channel.
                                                                </li>
                                                            </ul>
                                                        </p>
                                                        <p>
                                                            We will create a solid USSD that is simple to integrate so
                                                            we
                                                            can start offering your customers scalable options. By
                                                            integrating, we can make sure that your consumers only need
                                                            to
                                                            dial a short number to complete all of their purchases of
                                                            goods
                                                            and services rather than paying an additional fee to access
                                                            the
                                                            service online.
                                                        </p>
                                                        <div className="button-group">
                                                            <a className="btn-default btn-small"
                                                               href="tel:0713958492"> Read
                                                                More <i
                                                                    className="icon"><FiArrowRight/></i></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPanel>

                                            <TabPanel>
                                                <div className="rn-tab-content">
                                                    <div className="inner">
                                                        <p>
                                                            To help our clients establish bulk SMS campaigns, engage
                                                            their
                                                            customers, and expand their businesses, we provide bulk SMS
                                                            in
                                                            Kenya. With our Bulk SMS Services, Gateway Integration, and
                                                            Custom Solutions, we'll help you scale up text messaging.
                                                        </p>
                                                        <div className="button-group">
                                                            <a className="btn-default btn-small"
                                                               href="tel:0713958492"> Read
                                                                More <i
                                                                    className="icon"><FiArrowRight/></i></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Tabs>
                    </ScrollAnimation>
                </div>
            </div>
        </div>
    )
}

export default TabOne
